export default "/images/vendor/flag-icons/flags/1x1/sa.svg?dc431e9d11ed489ed3507ee35f32b0b9";